var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { "label-width": "100px" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员OpenID" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.consumerOpenId,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "consumerOpenId", $$v)
                      },
                      expression: "detailsData.consumerOpenId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员昵称" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.consumerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "consumerName", $$v)
                      },
                      expression: "detailsData.consumerName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "生日" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.dateOfBirth,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "dateOfBirth", $$v)
                      },
                      expression: "detailsData.dateOfBirth",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.consumerPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "consumerPhone", $$v)
                      },
                      expression: "detailsData.consumerPhone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "常驻区域" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.areaToBelong,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "areaToBelong", $$v)
                      },
                      expression: "detailsData.areaToBelong",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "注册时间" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.registrationDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "registrationDate", $$v)
                      },
                      expression: "detailsData.registrationDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "常用酒区域" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.commonlyAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "commonlyAddress", $$v)
                      },
                      expression: "detailsData.commonlyAddress",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "购酒渠道偏好" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.commonlyChannel,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "commonlyChannel", $$v)
                      },
                      expression: "detailsData.commonlyChannel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "系列偏好" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.seriesPreferencesName,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "seriesPreferencesName", $$v)
                      },
                      expression: "detailsData.seriesPreferencesName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "度数偏好" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.commonlyDegree,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "commonlyDegree", $$v)
                      },
                      expression: "detailsData.commonlyDegree",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "form-title" }, [_vm._v("收货地址")]),
              _c(
                "vxe-table",
                { attrs: { data: _vm.list } },
                [
                  _c("vxe-table-column", {
                    attrs: { field: "provinceName", title: "省" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "cityName", title: "市" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "districtName", title: "区" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "address", title: "详细地址" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "contactPersonName", title: "联系人" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "contactPersonPhone", title: "联系人电话" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "isDefault", title: "是否默认地址" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(row.isDefault === "1" ? "是" : "否")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }